function interceptorConfiguration($q, $injector) {
  return {
    request: function(config) {
      return config
    },

    requestError: (rejection) => {
      return $q.reject(rejection)
    },

    response: (response) => {
      return response
    },

    responseError: (rejection) => {
      if (rejection.status === -1) {
        $injector.get('toastService').showOffline()
      }
      return $q.reject(rejection)
    },
  }
}

export default ['$q', '$injector', interceptorConfiguration]
